import { ElementType, FC, ReactElement, ReactNode, useState } from 'react';
import { Box, BoxProps, Flex, Hide, Text, useBreakpointValue } from '@chakra-ui/react';
import { CbProfileInformation } from '../CbProfileInformation';
import Coins from '../Icons/Coins/Coins';
import Star from '../Icons/Star/Star';
import { CbButton } from '../Buttons/CbButton';
import { UserDisplay } from '../CbPlayerStub';
interface RowProps extends BoxProps {
  children: ReactNode;
}
const Row: FC<RowProps> = ({
  children,
  ...rest
}) => <Box display="flex" flexWrap="wrap" justifyContent="space-between" marginX="auto" {...rest} data-sentry-element="Box" data-sentry-component="Row" data-sentry-source-file="CbPlayerCard.tsx">
    {children}
  </Box>;
export interface CbPlayerCardProps {
  badgeUrl?: string;
  canGiveTokens?: boolean;
  image?: string;
  id: string;
  name: string;
  jobTitle?: string;
  location?: string;
  description?: string;
  handleGiveTokens: (playerObject: UserDisplay) => void;
  handleGiveRecognition: (id: string) => void;
  titleAdornment?: ReactElement;
  titleHref?: string;
  titleAs?: ElementType;
  isOwnProfile?: boolean;
  isSelected: boolean;
}
const DecoratedButton = ({
  text,
  icon,
  onClick,
  isMobile,
  ...props
}) => {
  if (isMobile) {
    return <CbButton aria-label={text} onClick={onClick} variant="ghost" {...props}>
        {icon}
      </CbButton>;
  }
  return <CbButton variant="ghost" leftIcon={icon} onClick={onClick} {...props} data-sentry-element="CbButton" data-sentry-component="DecoratedButton" data-sentry-source-file="CbPlayerCard.tsx">
      {text}
    </CbButton>;
};
export const CbPlayerCard: FC<CbPlayerCardProps> = ({
  badgeUrl,
  canGiveTokens = true,
  image,
  id,
  isOwnProfile = false,
  name,
  jobTitle,
  location,
  description,
  handleGiveTokens,
  handleGiveRecognition,
  titleAdornment,
  titleHref,
  titleAs,
  isSelected
}) => {
  const isMobile = useBreakpointValue({
    base: true,
    lg: false
  }, {
    ssr: false
  });
  const [showButtons, setShowButtons] = useState(false);
  const avatarSize = 'xl';
  const handleShowButtons = () => !isMobile && setShowButtons(true);
  const handleHideButtons = () => !isMobile && setShowButtons(false);

  // Buttons always show on mobile, on desktop we only want to show then when a user hovers
  const showable = isMobile || showButtons;
  const handleClickGiveTokens = (userDisplay, event) => {
    event.stopPropagation();
    handleGiveTokens(userDisplay);
  };
  const handleClickGiveRecognition = (userDisplay, event) => {
    event.stopPropagation();
    handleGiveRecognition(userDisplay);
  };
  return <Row backgroundColor={isSelected ? 'chonky.100' : 'white'} boxShadow="standardCard" borderRadius={24} justifyContent="space-between" maxWidth="100%" onMouseEnter={handleShowButtons} onMouseLeave={handleHideButtons} data-sentry-element="Row" data-sentry-component="CbPlayerCard" data-sentry-source-file="CbPlayerCard.tsx">
      <Box width={{
      base: '100%',
      lg: 'auto'
    }} data-sentry-element="Box" data-sentry-source-file="CbPlayerCard.tsx">
        <CbProfileInformation avatarSize={avatarSize} badgeUrl={badgeUrl} description={description} image={image} jobTitle={jobTitle} location={location} name={name} titleAdornment={titleAdornment} titleHref={titleHref} titleAs={titleAs} data-sentry-element="CbProfileInformation" data-sentry-source-file="CbPlayerCard.tsx" />
      </Box>
      <Flex paddingX={8} paddingY={4} paddingTop={{
      base: 0,
      lg: 4
    }} flexDirection={{
      lg: 'column'
    }} justifyContent="space-between" alignItems={{
      base: 'center',
      lg: 'baseline'
    }} width={{
      base: '100%',
      lg: 'auto'
    }} data-sentry-element="Flex" data-sentry-source-file="CbPlayerCard.tsx">
        {!isOwnProfile && <>
            <Hide above="lg">
              <Text flex="1" fontWeight="bold" fontSize="lg" color="text.secondary">
                {'Spread the love:'}
              </Text>
            </Hide>
            {showable && <>
                <DecoratedButton marginLeft={{
            base: 4,
            lg: 0
          }} marginBottom={{
            lg: 4
          }} width={{
            base: '40px',
            lg: '100%'
          }} isMobile={isMobile} minWidth="40px" icon={<Star width="16px" />} round={isMobile} text={'Give Star'} onClick={event => handleClickGiveRecognition(id, event)} />
                {canGiveTokens && <DecoratedButton marginLeft={{
            base: 4,
            lg: 0
          }} width={{
            base: '40px',
            lg: '100%'
          }} isMobile={isMobile} round={isMobile} minWidth="40px" icon={<Coins width="16px" />} text={'Give Tokens'} onClick={event => handleClickGiveTokens({
            id,
            name,
            image
          }, event)} />}
              </>}
          </>}
      </Flex>
    </Row>;
};